import React from 'react';
import { API_BASE } from '../../config';
import {
  MDBBtn,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBRadio,
  MDBSelect
}
from 'mdb-react-ui-kit';
import { Box, Button, FormControl, FormLabel, Input, useToast,
  Select,
  Text,
  Radio,
  RadioGroup,
  Stack,
  useRadio,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
 } from "@chakra-ui/react";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import wallpaper from '../UI/Images/tealWall.jpg'

//mdb style
import 'mdb-react-ui-kit/dist/css/mdb.min.css';

import Navigation from "../UI/Navigation";
import '../UI/innerPages.css';
const PharmacistRegisterPage = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    name: '',
    email: '',
    mobile: '',
    latitude: '',
    longitude: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    discount: '',
    mondayClosed: false,
    mondayFrom: '',
    mondayTo: '',
    tuesdayClosed: false,
    tuesdayFrom: '',
    tuesdayTo: '',
    wednesdayClosed: false,
    wednesdayFrom: '',
    wednesdayTo: '',
    thursdayClosed: false,
    thursdayFrom: '',
    thursdayTo: '',
    fridayClosed: false,
    fridayFrom: '',
    fridayTo: '',
    saturdayClosed: false,
    saturdayFrom: '',
    saturdayTo: '',
    sundayClosed: false,
    sundayFrom: '',
    sundayTo: '',
  });
  const back =()=>  navigate(-1);

  const onChange = e => {
    const { name, type, value } = e.target;
    if (type === 'checkbox') {
      const checked = e.target.checked;
      setFormData(formData => ({ ...formData, [name]: checked }));
    } else {
      setFormData(formData => ({ ...formData, [name]: value }));
    }
  };

  const onSubmit = async e => {
    e.preventDefault();

    const latitude = Number.parseFloat(formData.latitude);
    const longitude = Number.parseFloat(formData.longitude);
    const hasValidLocation = Number.isFinite(latitude) && Number.isFinite(longitude);
    const isIndiaLocation = latitude >= 6.5546079 && latitude <= 35.6745457 && longitude >= 68.1113787 && longitude <= 97.395561;
    if (!hasValidLocation || latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180 || !isIndiaLocation) {
      toast({
        title: 'Invalid location',
        description: 'Please enter latitude/longitude within India.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      toast({
        title: 'Invalid email',
        description: 'Please enter a valid email address.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    if (!/^(?:\+91|91|0)?[6-9]\d{9}$/.test(String(formData.mobile).trim())) {
      toast({
        title: 'Invalid phone number',
        description: 'Please enter a valid India mobile number (10 digits starting with 6-9, optional +91).',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const discount = Number.parseFloat(formData.discount);
    if (!Number.isFinite(discount) || discount < 0 || discount > 100) {
      toast({
        title: 'Invalid discount',
        description: 'Discount must be a number between 0 and 100.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const timeRegex = /^\d{2}:\d{2}$/;
    const days = [
      { key: 'monday', label: 'Monday', closed: formData.mondayClosed, from: formData.mondayFrom, to: formData.mondayTo },
      { key: 'tuesday', label: 'Tuesday', closed: formData.tuesdayClosed, from: formData.tuesdayFrom, to: formData.tuesdayTo },
      { key: 'wednesday', label: 'Wednesday', closed: formData.wednesdayClosed, from: formData.wednesdayFrom, to: formData.wednesdayTo },
      { key: 'thursday', label: 'Thursday', closed: formData.thursdayClosed, from: formData.thursdayFrom, to: formData.thursdayTo },
      { key: 'friday', label: 'Friday', closed: formData.fridayClosed, from: formData.fridayFrom, to: formData.fridayTo },
      { key: 'saturday', label: 'Saturday', closed: formData.saturdayClosed, from: formData.saturdayFrom, to: formData.saturdayTo },
      { key: 'sunday', label: 'Sunday', closed: formData.sundayClosed, from: formData.sundayFrom, to: formData.sundayTo },
    ];

    for (const d of days) {
      if (d.closed) continue;
      if (!timeRegex.test(String(d.from)) || !timeRegex.test(String(d.to))) {
        toast({
          title: 'Invalid working hours',
          description: `${d.label} hours must be in HH:MM format.`,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return;
      }
    }

    const workingHours = {
      monday: { closed: Boolean(formData.mondayClosed), from: String(formData.mondayFrom), to: String(formData.mondayTo) },
      tuesday: { closed: Boolean(formData.tuesdayClosed), from: String(formData.tuesdayFrom), to: String(formData.tuesdayTo) },
      wednesday: { closed: Boolean(formData.wednesdayClosed), from: String(formData.wednesdayFrom), to: String(formData.wednesdayTo) },
      thursday: { closed: Boolean(formData.thursdayClosed), from: String(formData.thursdayFrom), to: String(formData.thursdayTo) },
      friday: { closed: Boolean(formData.fridayClosed), from: String(formData.fridayFrom), to: String(formData.fridayTo) },
      saturday: { closed: Boolean(formData.saturdayClosed), from: String(formData.saturdayFrom), to: String(formData.saturdayTo) },
      sunday: { closed: Boolean(formData.sundayClosed), from: String(formData.sundayFrom), to: String(formData.sundayTo) },
    };

    const payload = {
      username: formData.username,
      password: formData.password,
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      latitude: formData.latitude,
      longitude: formData.longitude,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      pincode: formData.pincode,
      discount: String(discount),
      workingHours,
    };
    try {
        const response = await axios.post(`${API_BASE}/doc_register`, payload, {
            withCredentials: true,
          });
          

      if (response.data.success) {
        toast({
          title: 'Registration Successful',
          description: response.data.message,
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        navigate('/'); // Redirect to the home page or login page
      } else {
        toast({
          title: 'Registration Failed',
          description: response.data.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      let errorMessage = "Registration failed due to an unexpected error.";
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      toast({
        title: 'Registration Failed',
        description: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Pharmacist onboarding is offline</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Pharmacist onboarding is currently unavailable online. Please contact us to register:
          </Text>
          <Text fontSize='2xl' fontWeight='bold' mt={4}>
            +91 99888 61071
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme='teal' mr={3} onClick={() => navigate('/')}>
            Go to Home
          </Button>
          <Button variant='ghost' onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
    <MDBContainer fluid className=' d-flex justify-content-center'  
    style={{height:'max-content', backgroundImage: `url(${wallpaper})`, backgroundSize: 'cover', backgroundPosition: 'center'}}
     >
      
      <MDBRow className=' d-flex justify-content-center align-items-center w-75' style={{height:'fit-content'}} >
        <MDBCol >
        <Navigation pagetitle={""}  />
          <MDBCard className='my-4' style={{    
            //frosty glass effect
            backgroundColor: 'rgba(255, 255, 255, 0.5)', // Adjust opacity as needed
            backdropFilter: 'blur(5px)'  
           }}>
            <h3 className="text-uppercase fw-bold pt-5 ps-5">Pharmacist Registration Form</h3>

            <MDBRow className='g-0 '>
              <MDBCol lg={'6'} md='12' sm={'12'} className="d-none d-md-block">
              <MDBCardBody className='text-black d-flex flex-column justify-content-center'>
                  <Text> Personal Information </Text>
                  <MDBRow >
                    <MDBCol >
                      <MDBInput wrapperClass='mb-4' label='Full Name' size='lg' id='form1' name='name' type='text' onChange={onChange}/>
                    </MDBCol>
                  </MDBRow>

                <MDBInput wrapperClass='mb-4' name='mobile' label='Phone Number' size='lg' id='form10' type='number' onChange={onChange}/>

                <MDBInput wrapperClass='mb-4' label='Email' placeholder='pillstack@example.com' size='lg' id='form4' type='email' name='email' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='Address' size='lg' id='form4' type='text' name='address' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='City' size='lg' id='form4' type='text' name='city' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='State' size='lg' id='form4' type='text' name='state' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='Pincode' size='lg' id='form4' type='text' name='pincode' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='Discount (%)' size='lg' id='form4' type='number' name='discount' min={0} max={100} step="any" onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='Username' placeholder='Create a Username' name='username' size='lg' id='form5' type='Username' onChange={onChange}/>
                <MDBInput wrapperClass='mb-4' label='Password' size='lg' id='form6' name='password' type='password' onChange={onChange}/>

                </MDBCardBody>
                {/* <MDBCardImage src='https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp' alt="Sample photo" className="rounded-start" fluid/> */}
              </MDBCol>

              <MDBCol md='6'>
              <MDBCardBody className='text-black d-flex flex-column justify-content-center'>
              <Text> Location Information </Text>

                  <MDBRow >

                  <MDBCol >
                    <MDBInput wrapperClass='mb-4' label='Latitude' size='lg' id='form1' type='number' name='latitude' min={6.5546079} max={35.6745457} step="any" onChange={onChange}/>
                  </MDBCol>

                  </MDBRow>

                  <MDBRow >

                  <MDBCol >
                    <MDBInput wrapperClass='mb-4' label='Longitude' size='lg' id='form1' type='number' name='longitude' min={68.1113787} max={97.395561} step="any" onChange={onChange}/>
                  </MDBCol>

                  </MDBRow>
                  <Text> Working Hours (HH:MM) </Text>

                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='mondayClosed' isChecked={formData.mondayClosed} onChange={onChange}>Monday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.mondayClosed} value={formData.mondayFrom} wrapperClass='mb-4' label='Monday From' size='lg' type='text' name='mondayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.mondayClosed} value={formData.mondayTo} wrapperClass='mb-4' label='Monday To' size='lg' type='text' name='mondayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='tuesdayClosed' isChecked={formData.tuesdayClosed} onChange={onChange}>Tuesday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.tuesdayClosed} value={formData.tuesdayFrom} wrapperClass='mb-4' label='Tuesday From' size='lg' type='text' name='tuesdayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.tuesdayClosed} value={formData.tuesdayTo} wrapperClass='mb-4' label='Tuesday To' size='lg' type='text' name='tuesdayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='wednesdayClosed' isChecked={formData.wednesdayClosed} onChange={onChange}>Wednesday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.wednesdayClosed} value={formData.wednesdayFrom} wrapperClass='mb-4' label='Wednesday From' size='lg' type='text' name='wednesdayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.wednesdayClosed} value={formData.wednesdayTo} wrapperClass='mb-4' label='Wednesday To' size='lg' type='text' name='wednesdayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='thursdayClosed' isChecked={formData.thursdayClosed} onChange={onChange}>Thursday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.thursdayClosed} value={formData.thursdayFrom} wrapperClass='mb-4' label='Thursday From' size='lg' type='text' name='thursdayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.thursdayClosed} value={formData.thursdayTo} wrapperClass='mb-4' label='Thursday To' size='lg' type='text' name='thursdayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='fridayClosed' isChecked={formData.fridayClosed} onChange={onChange}>Friday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.fridayClosed} value={formData.fridayFrom} wrapperClass='mb-4' label='Friday From' size='lg' type='text' name='fridayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.fridayClosed} value={formData.fridayTo} wrapperClass='mb-4' label='Friday To' size='lg' type='text' name='fridayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='saturdayClosed' isChecked={formData.saturdayClosed} onChange={onChange}>Saturday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.saturdayClosed} value={formData.saturdayFrom} wrapperClass='mb-4' label='Saturday From' size='lg' type='text' name='saturdayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.saturdayClosed} value={formData.saturdayTo} wrapperClass='mb-4' label='Saturday To' size='lg' type='text' name='saturdayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow className='align-items-end'>
                    <MDBCol md='3' className='d-flex align-items-end'>
                      <div className='mb-4'>
                        <Checkbox name='sundayClosed' isChecked={formData.sundayClosed} onChange={onChange}>Sunday Closed</Checkbox>
                      </div>
                    </MDBCol>
                    <MDBCol md='4'>
                      <MDBInput disabled={formData.sundayClosed} value={formData.sundayFrom} wrapperClass='mb-4' label='Sunday From' size='lg' type='text' name='sundayFrom' placeholder='09:00' onChange={onChange} />
                    </MDBCol>
                    <MDBCol md='5'>
                      <MDBInput disabled={formData.sundayClosed} value={formData.sundayTo} wrapperClass='mb-4' label='Sunday To' size='lg' type='text' name='sundayTo' placeholder='18:00' onChange={onChange} />
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCol>
            </MDBRow>
            <MDBRow className='g-0 p-2'>
              <div className="d-flex justify-content-end pt-3">
              <div className="d-flex justify-content-end pt-3">
                                  
                                  { formData.username !== '' &&
                      formData.name !== '' &&
                      formData.email !== '' &&                     
                      formData.mobile !== '' &&
                      formData.address !== '' &&
                      formData.city !== '' &&
                      formData.state !== '' &&
                      formData.pincode !== '' &&
                      formData.discount !== '' &&
                      formData.password !== '' &&
                      formData.latitude !== '' &&
                      formData.longitude !== '' &&
                      (formData.mondayClosed || (formData.mondayFrom !== '' && formData.mondayTo !== '')) &&
                      (formData.tuesdayClosed || (formData.tuesdayFrom !== '' && formData.tuesdayTo !== '')) &&
                      (formData.wednesdayClosed || (formData.wednesdayFrom !== '' && formData.wednesdayTo !== '')) &&
                      (formData.thursdayClosed || (formData.thursdayFrom !== '' && formData.thursdayTo !== '')) &&
                      (formData.fridayClosed || (formData.fridayFrom !== '' && formData.fridayTo !== '')) &&
                      (formData.saturdayClosed || (formData.saturdayFrom !== '' && formData.saturdayTo !== '')) &&
                      (formData.sundayClosed || (formData.sundayFrom !== '' && formData.sundayTo !== '')) ? 
                      
                      
                      <Button
                      variant={'solid'} colorScheme="teal" size={'lg'} type="submit"
                      onClick={onSubmit}
                      >Submit</Button> : <Button
                      isDisabled ={ true}
                      variant={'solid'} colorScheme="teal" size={'lg'} type="submit"
                      >Please fill all fields
                                </Button>}
            </div>
              </div>
            </MDBRow>
          </MDBCard>

        </MDBCol>
      </MDBRow>

    </MDBContainer>
    </>
  );
  };
  export default PharmacistRegisterPage;